import { useState } from "react";
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from "recoil";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import { userState } from "src/store/user/userState";
import { listReservationsRecentsFetchState, reservationsRecentsState } from "../state/atoms";
import ManageStorage from "src/shared/global/manageStorage";
import { parseJwt } from "src/shared/global/helpers";

const useReservationsPatient = () => {

    const [loading, setLoading] = useState(false);
    const user = useRecoilValue(userState);
    const setReservationsRecents = useSetRecoilState(reservationsRecentsState);
    const { catchErrorApi } = useCatchErrorApi()

    const reservationsRecentsCallback = useRecoilCallback(({ snapshot }) => async () => {
        setLoading(true)
        const payloadToken = parseJwt(ManageStorage.getValueFromStorage("tokenUser"));
        console.log('payloadToken', payloadToken);
        
        try {
            if (payloadToken) {
                const reservationsFetch = await snapshot.getPromise(listReservationsRecentsFetchState(payloadToken.Username));
                //-----
                setReservationsRecents(reservationsFetch)
            }
        } catch (error) {
            catchErrorApi(error);
        } finally {
            setLoading(false)
        }
    }, []);

    return {
        reservationsRecentsCallback,
        loading
    }

};

export default useReservationsPatient;
